import FormRemunaciones from "./FormPrincipal";

export default function AddRemunacion() {
    return (
        <FormRemunaciones/>
    )
}